import { useMemo } from 'react';
import { IProject } from 'redux-store/api/projects';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';

export const useWritableProjects = (projects?: IProject[]) => {
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();

  const writableProjects = useMemo(() => {
    const canManageSchedule = userPermissions?.MANAGE_SCHEDULE?.canCreate;

    if (!canManageSchedule || !projects?.length) {
      return [];
    }

    return projects;
  }, [projects, userPermissions]);

  return writableProjects;
};
